import React from 'react';
import GameBase from '../components/base/game-base';

const TourneysComponentsFormRulesPartGame = () => {
  return <GameBase sportType="general" />;
};

export default TourneysComponentsFormRulesPartGame;
